import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from '../AppModule/LoginComponent/login.component';

const loginRoutes: Routes = [
    {path: 'login', component: LoginComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(loginRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})
export class LoginRouterModule {
}



// WEBPACK FOOTER //
// /app/src/routers/login-router.module.ts